module.exports = __webpack_public_path__ + "static/media/classes_l.2730f84a.jpg";